import { getRSSAppSettings } from '@/helpers/utils';

export default {
  computed: {
    templateDimensions() {
      const { width = 0, height = 0 } = this.template?.settings || {};
      return {
        templateWidth: width,
        templateHeight: height,
        templateRatio: 1,
      };
    },
  },

  methods: {
    defaultStyling(widget) {
      const position = widget.position;
      const usePixels = widget.position.usePixels && typeof position.xPixels === 'number';

      return {
        left: usePixels ? `${position.xPixels}px` : `${position.x}%`,
        top: usePixels ? `${position.yPixels}px` : `${position.y}%`,
        height: usePixels ? `${position.heightPixels}px` : `${position.height}%`,
        width: usePixels ? `${position.widthPixels}px` : `${position.width}%`,
        borderRadius: `${widget.object.borderRadius || 0}px`,
        zIndex: 100 + position.zIndex,
        opacity: position.isHidden ? 0 : 1,
      };
    },

    getRSSAppSettings,
  },

  inject: ['template'],
};
